<div class="course-item-list"  *ngIf="!showNoCourseMessage">
	<h2 class="heading--3">Courses you added or imported</h2>
	<p *ngIf="!ccpAudit">Use the ‘pencil’ icon to edit the Course Type. For example, use the edit feature to change a course listed in the Adult Critical Care category to the General Respiratory Care category. </p>
	<hr>
	<div class="course-item" *ngFor="let c of courseList">
		<h3 class="course-item__name">{{c?.courseName}}</h3>
		<span class="course-item__hours">
			{{c?.courseHours}} Hour<span *ngIf="c?.courseHours > 1">s</span>
		</span>
		<div class="course-item__data-items">
			<span class="course-item__data-item">{{c?.courseUsageType}}</span>
			<span class="course-item__data-item">{{c?.courseCategory}}</span>
			<span class="course-item__data-item">Completed: {{ c?.completionDate | amDateFormat: 'LL' }}</span>
		</div>
		<div *ngIf="!ccpAudit" class="course-item__actions item-actions">
			<button routerLink="/practitioner/credentials-maintenance/courses/update/{{c?.id}}" class="button button--bare icon icon--pencil"><span class="is-vishidden">Edit</span></button>
			<button class="button button--bare icon icon--trash" (click)="deleteCourse(c?.id)"><span class="is-vishidden">Delete</span></button>
		</div>
	</div>
</div>
<div *ngIf="showNoCourseMessage">You have not added or imported courses yet</div>
